import AddIcon from "@mui/icons-material/Add";
import FormHelperText from "@mui/material/FormHelperText";
import Grid from "@mui/material/Grid";
import { useFormik } from "formik";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import * as yup from "yup";
import {
  getDetailExcoPusat,
  patchExcoDetail,
} from "../../../config/Redux/ExcoPusat/actions";
import { getBank } from "../../../config/Redux/Global/actions";
import { Gap, MyAutocomplete, MyButton, MyInput } from "../../atoms";
import MyDialog from "../../molecules/Dialog";
import AlertMessage from "../../../components/molecules/AlertMessage";
import "./detailexco.css";
import { LOCAL_STORAGE_KEY } from "../../../config/API/config";

const validationSchema = yup.object().shape({
  bank: yup
    .object()
    .shape({
      label: yup.string(),
      id: yup.string(),
    })
    .nullable()
    .required("Silahkan Pilih Bank"),
  nama_bank: yup.string().nullable(),
  // .required("Silahkan Masukan NPWP"),
  cabang_bank: yup.string().nullable().required("Silahkan Masukan Cabang Bank"),
  no_rekening: yup.string().nullable().required("Silahkan Masukan No Rekening"),
  pemilik_rekening: yup
    .string()
    .nullable()
    .required("Silahkan Masukan Pemilik Rekening"),
});

const BankKantor = ({
  officeId: propOfficeId,
  tingkatExcoId: propTingkatExcoId,
  daerahId: propDaerahId,
  isLocked: propIsLocked,
}) => {
  const dataDetailExcoPusat = useSelector(
    (state) => state.excopusat.dataDetailExcoPusat,
  );

  let dataDetail = dataDetailExcoPusat && dataDetailExcoPusat.data;
  const urlParams = useParams();
  // Use props if available, otherwise fallback to URL params
  const officeId = propOfficeId || urlParams.officeId;
  const tingkatExcoId = propTingkatExcoId || urlParams.tingkatExcoId;
  const daerahId = propDaerahId || urlParams.daerahId;
  // Use prop for isLocked if provided, otherwise fallback to Redux state
  const isLocked =
    propIsLocked !== undefined
      ? propIsLocked
      : parseInt(dataDetailExcoPusat?.data?.is_locked) === 1;

  const dispatch = useDispatch();
  const [openDialog, setOpenDialog] = React.useState(false);
  // const [idProvinsi, setIdProvinsi] = React.useState(null);

  // alert message
  const [openDialogAlert, setOpenDialogAlert] = React.useState(false);
  const [message, setMessage] = React.useState("");
  const [status, setStatus] = React.useState(null);

  //  selector
  const bank = useSelector((state) => state.global.dataBank);
  // console.log("kk",s)

  const profile = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY));
  //cek hak akses
  const checkHakAkses = (list, akses, is_locked) => {
    let has = false;
    list?.map((val) => {
      if (val.hak_akses === akses) {
        has = true;
      }
      if (val.hak_akses === "Super Admin Semata") {
        has = true;
      }
      return val;
    });
    return has;
  };

  const formik = useFormik({
    initialValues: {
      bank:
        dataDetail?.data_bank?.id_bank && dataDetail?.data_bank?.nama_bank
          ? {
              id: dataDetail?.data_bank?.id_bank,
              label: dataDetail?.data_bank?.nama_bank,
            }
          : null,
      nama_bank_lainnya: dataDetail?.data_bank?.bank_lainnya || "",
      cabang_bank: dataDetail?.data_bank?.cabang || "",
      no_rekening: dataDetail?.data_bank?.no_rekening || "",
      pemilik_rekening: dataDetail?.data_bank?.pemilik_rekening || "",
      bank_kampanye:
        dataDetail?.data_bank?.id_bank_kampanye &&
        dataDetail?.data_bank?.nama_bank_kampanye
          ? {
              id: dataDetail?.data_bank?.id_bank_kampanye,
              label: dataDetail?.data_bank?.nama_bank_kampanye,
            }
          : null,
      bank_lainnya_kampanye: dataDetail?.data_bank?.bank_lainnya_kampanye || "",
      cabang_bank_kampanye: dataDetail?.data_bank?.cabang_bank_kampanye || "",
      no_rekening_kampanye: dataDetail?.data_bank?.no_rekening_kampanye || "",
      pemilik_rekening_kampanye:
        dataDetail?.data_bank?.pemilik_rekening_kampanye || "",
    },
    enableReinitialize: true,
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      let payload = {
        id_bank: values.bank?.id || null,
        nama_bank_lainnya: values.nama_bank_lainnya,
        cabang_bank: values.cabang_bank,
        no_rekening: values.no_rekening,
        pemilik_rekening: values.pemilik_rekening,
        id_bank_kampanye: values.bank_kampanye?.id || null,
        bank_lainnya_kampanye: values.bank_lainnya_kampanye,
        cabang_bank_kampanye: values.cabang_bank_kampanye,
        no_rekening_kampanye: values.no_rekening_kampanye,
        pemilik_rekening_kampanye: values.pemilik_rekening_kampanye,
      };
      // console.log(`payload`, payload);
      const resp = await dispatch(patchExcoDetail(officeId, payload));
      if (resp.type === "PATCH_EXCO_PUSAT_SUCCESS") {
        handleCloseDialog();
        await dispatch(getDetailExcoPusat(tingkatExcoId, daerahId));
        setMessage(resp.payload.message);
        setOpenDialogAlert(true);
        setStatus("");
      } else {
        setMessage(resp.payload.data.message);
        setOpenDialogAlert(true);
        setStatus("error");
      }
    },
  });
  const handleOpenDialog = () => {
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    formik.resetForm();
    setOpenDialog(false);
  };

  let optionsBank = bank?.data?.map((item) => ({
    label: item.nama_bank,
    id: item.id_bank,
  }));

  const renderValue = (
    <>
      <div align="center" style={{ fontSize: 22, fontWeight: 700 }}>
        <p>Ubah Data</p>
      </div>
      <form
        onSubmit={(e) => {
          e.preventDefault();
          formik.handleSubmit(e);
        }}
      >
        <MyAutocomplete
          id="bank"
          name="bank"
          fullWidth
          options={optionsBank || []}
          // handleChange={(e, value) => formik.setFieldValue("provinsi", value)}
          size="medium"
          label="Bank*"
          renderInput={(params) => <MyInput {...params} label="Bank*" />}
          value={formik.values.bank}
          onChange={(e, value) => {
            formik.setFieldValue("bank", value);
          }}
        />
        <FormHelperText id="component-error-text" style={{ color: "red" }}>
          {formik.touched.bank && formik.errors.bank}
        </FormHelperText>
        <Gap height={10} />
        {formik.values.bank?.id === 1 ? (
          <>
            <MyInput
              id="nama_bank_lainnya"
              name="nama_bank_lainnya"
              label="Nama Bank"
              fullWidth
              size="medium"
              value={formik.values.nama_bank_lainnya}
              onChange={formik.handleChange}
              error={
                formik.touched.nama_bank && Boolean(formik.errors.nama_bank)
              }
              helperText={formik.touched.nama_bank && formik.errors.nama_bank}
            />
            <Gap height={10} />
          </>
        ) : null}
        <MyInput
          id="cabang_bank"
          name="cabang_bank"
          label="Cabang Bank*"
          fullWidth
          size="medium"
          value={formik.values.cabang_bank}
          onChange={formik.handleChange}
          error={
            formik.touched.cabang_bank && Boolean(formik.errors.cabang_bank)
          }
          helperText={formik.touched.cabang_bank && formik.errors.cabang_bank}
        />
        <Gap height={10} />
        <MyInput
          id="no_rekening"
          name="no_rekening"
          label="Nomer Rekening*"
          fullWidth
          size="medium"
          value={formik.values.no_rekening}
          onChange={formik.handleChange}
          error={
            formik.touched.no_rekening && Boolean(formik.errors.no_rekening)
          }
          helperText={formik.touched.no_rekening && formik.errors.no_rekening}
          multiline
        />
        <Gap height={10} />
        <MyInput
          id="pemilik_rekening"
          name="pemilik_rekening"
          label="Pemilik Rekening*"
          fullWidth
          size="medium"
          value={formik.values.pemilik_rekening}
          onChange={formik.handleChange}
          error={
            formik.touched.pemilik_rekening &&
            Boolean(formik.errors.pemilik_rekening)
          }
          helperText={
            formik.touched.pemilik_rekening && formik.errors.pemilik_rekening
          }
          multiline
        />
        <Gap height={10} />
        <MyAutocomplete
          id="bank_kampanye"
          name="bank_kampanye"
          fullWidth
          options={optionsBank || []}
          // handleChange={(e, value) => formik.setFieldValue("provinsi", value)}
          size="medium"
          label="Bank Dana Kampanye"
          renderInput={(params) => (
            <MyInput {...params} label="Bank Dana Kampanye" />
          )}
          value={formik.values.bank_kampanye}
          onChange={(e, value) => {
            formik.setFieldValue("bank_kampanye", value);
          }}
        />
        <FormHelperText id="component-error-text" style={{ color: "red" }}>
          {formik.touched.bank_kampanye && formik.errors.bank_kampanye}
        </FormHelperText>
        <Gap height={10} />
        {formik.values.bank_kampanye?.id === 1 ? (
          <>
            <MyInput
              id="bank_lainnya_kampanye"
              name="bank_lainnya_kampanye"
              label="Nama Bank Kampanye Dana Kampanye"
              fullWidth
              size="medium"
              value={formik.values.bank_lainnya_kampanye}
              onChange={formik.handleChange}
              error={
                formik.touched.bank_lainnya_kampanye && Boolean(formik.errors.bank_lainnya_kampanye)
              }
              helperText={formik.touched.bank_lainnya_kampanye && formik.errors.bank_lainnya_kampanye}
            />
            <Gap height={10} />
          </>
        ) : null}
        <MyInput
          id="cabang_bank_kampanye"
          name="cabang_bank_kampanye"
          label="Cabang Bank Dana Kampanye"
          fullWidth
          size="medium"
          value={formik.values.cabang_bank_kampanye}
          onChange={formik.handleChange}
          error={
            formik.touched.cabang_bank_kampanye && Boolean(formik.errors.cabang_bank_kampanye)
          }
          helperText={formik.touched.cabang_bank_kampanye && formik.errors.cabang_bank_kampanye}
        />
        <Gap height={10} />
        <MyInput
          id="no_rekening_kampanye"
          name="no_rekening_kampanye"
          label="Nomer Rekening Dana Kampanye"
          fullWidth
          size="medium"
          value={formik.values.no_rekening_kampanye}
          onChange={formik.handleChange}
          error={
            formik.touched.no_rekening_kampanye && Boolean(formik.errors.no_rekening_kampanye)
          }
          helperText={formik.touched.no_rekening_kampanye && formik.errors.no_rekening_kampanye}
          multiline
        />
        <Gap height={10} />
        <MyInput
          id="pemilik_rekening_kampanye"
          name="pemilik_rekening_kampanye"
          label="Pemilik Rekening Dana Kampanye"
          fullWidth
          size="medium"
          value={formik.values.pemilik_rekening_kampanye}
          onChange={formik.handleChange}
          error={
            formik.touched.pemilik_rekening_kampanye &&
            Boolean(formik.errors.pemilik_rekening_kampanye)
          }
          helperText={
            formik.touched.pemilik_rekening_kampanye && formik.errors.pemilik_rekening_kampanye
          }
          multiline
        />
        <Gap height={10} />
        <div style={{ display: "flex" }}>
          <MyButton
            height="40px"
            color="#B9B9B9"
            fullWidth
            backgroundColor="#FFFFFFFF"
            borderColor="#B9B9B9"
            backgroundColorHover="#FFFFFFFF"
            variant="outlined"
            children="Batal"
            onClick={handleCloseDialog}
          />
          <Gap width={30} />
          <MyButton
            height="40px"
            color="#8B8B8B"
            colorHover="white"
            fullWidth
            backgroundColor="#E8E8E8"
            borderColor="#E8E8E8"
            backgroundColorHover="#F06524"
            variant="outlined"
            children="Simpan"
            type="submit"
          />
        </div>
      </form>
    </>
  );

  useEffect(() => {
    dispatch(getBank());
    if (tingkatExcoId && daerahId) {
      dispatch(getDetailExcoPusat(tingkatExcoId, daerahId));
    }
  }, [dispatch, tingkatExcoId, daerahId]);
  return (
    <>
      <MyDialog
        openDialog={openDialog}
        handleCloseDialog={handleCloseDialog}
        renderValue={renderValue}
        fullWidth={true}
        maxWidth={"sm"}
      />

      {/* alertMessage */}
      <AlertMessage
        openDialog={openDialogAlert}
        message={message}
        status={status}
        handleCloseDialog={() => setOpenDialogAlert(false)}
      />
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginTop: -15,
        }}
      >
        <p style={{ fontSize: 22, color: "#8B8B8B" }}>Informasi Bank</p>
        {!isLocked &&
        (checkHakAkses(profile?.data?.hak_akses, "Document Admin Access") ||
          checkHakAkses(
            profile?.data?.hak_akses,
            "Document Manager Access",
          )) ? (
          <MyButton
            style={{ marginTop: 25 }}
            startIcon={<AddIcon />}
            height="100%"
            color="white"
            backgroundColor="#FF9000"
            borderColor="#FF9000"
            backgroundColorHover="#FF9000"
            variant="outlined"
            children="Ubah Informasi Bank"
            onClick={handleOpenDialog}
          />
        ) : null}
      </div>
      <Grid container spacing={3}>
        <Grid item xs={12} md={6}>
          <Gap height={20} />
          <table>
            <tbody>
              <tr>
                <td>Bank Rekening EXCO</td>
                <td>
                  : {dataDetail?.data_bank?.nama_bank || ""}{" "}
                  {dataDetail?.data_bank?.id_bank === 1
                    ? "(" + dataDetail?.data_bank?.bank_lainnya + ")"
                    : ""}
                </td>
              </tr>
              <tr>
                <td>Cabang Rekening EXCO</td>
                <td>: {dataDetail?.data_bank?.cabang || ""}</td>
              </tr>
              <tr>
                <td>Nomer Rekening EXCO</td>
                <td>: {dataDetail?.data_bank?.no_rekening || ""}</td>
              </tr>
              <tr>
                <td>Pemilik Rekening EXCO</td>
                <td>: {dataDetail?.data_bank?.pemilik_rekening || ""}</td>
              </tr>
            </tbody>
          </table>
        </Grid>
        <Grid item xs={12} md={6}>
          <Gap height={20} />
          <table>
            <tbody>
              <tr>
                <td>Bank Rekening Dana Kampanye</td>
                <td>
                  : {dataDetail?.data_bank?.nama_bank_kampanye || ""}{" "}
                  {dataDetail?.data_bank?.id_bank_kampanye === 1
                    ? "(" + dataDetail?.data_bank?.bank_lainnya_kampanye + ")"
                    : ""}
                </td>
              </tr>
              <tr>
                <td>Cabang Rekening Dana Kampanye </td>
                <td>: {dataDetail?.data_bank?.cabang_bank_kampanye || ""}</td>
              </tr>
              <tr>
                <td>Nomer Rekening Dana Kampanye </td>
                <td>: {dataDetail?.data_bank?.no_rekening_kampanye || ""}</td>
              </tr>
              <tr>
                <td>Pemilik Rekening Dana Kampanye </td>
                <td>
                  : {dataDetail?.data_bank?.pemilik_rekening_kampanye || ""}
                </td>
              </tr>
            </tbody>
          </table>
        </Grid>
        <Gap height={20} />
      </Grid>
    </>
  );
};

export default BankKantor;
